import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import NgwAvatar from "./common/ngwAvatar";

const UserSidebar: React.FC = () => {
  const user = useSelector((state: RootState) => state.user.user);

  return (
    <div className="bg-gray-100 h-full p-4 shadow-md">
      <div className="flex flex-col items-center mb-6 pt-4">
        <div className="mb-3">
          <NgwAvatar 
            src={user?.os_emp_image_name} 
            name={`${user?.os_emp_first_name || ''} ${user?.os_emp_last_name || ''}`}
            className="w-20 h-20"
          />
        </div>
        <h2 className="text-xl font-medium">
          {user?.os_emp_first_name} {user?.os_emp_last_name}
        </h2>
        <p className="text-gray-600 text-sm">{user?.os_emp_email}</p>
      </div>

      <div className="border-t pt-4">
        <h3 className="font-medium mb-2">Employee Info</h3>
        <div className="space-y-2">
          
          <div>
            <span className="text-gray-500 text-sm block">Department</span>
            <span className="font-medium">{user?.department_code || "Not assigned"}</span>
          </div>
          <div>
            <span className="text-gray-500 text-sm block">Job Title</span>
            <span className="font-medium">{user?.default_work_code_number || "Not assigned"}</span>
          </div>
        </div>
      </div>

      <div className="border-t mt-4 pt-4">
        <h3 className="font-medium mb-2">Contact</h3>
        <div className="space-y-2">
          <div>
            <span className="text-gray-500 text-sm block">Email</span>
            <span className="font-medium text-sm break-words">{user?.os_emp_email}</span>
          </div>
          <div>
            <span className="text-gray-500 text-sm block">Phone</span>
            <span className="font-medium">{user?.os_emp_phone || "Not provided"}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserSidebar;
